<mf-page title="Plantillas">
  <mf-row>
    <mf-grid
      #grid
      [apiEndpoint]="apiEndpoint"
      [actionButtons]="gridActionButtons"
      [columns]="columns"
      [menuItems]="menuItems" />
  </mf-row>
</mf-page>
